import { LitElement, html, css, styleMap, utils } from '@hh/global.js'
class HHStickyHeader extends LitElement {
  static properties = {
    closeWhenHidden: {
      type: String,
      attribute: 'close-when-hidden',
    },
    _state: {
      type: Number,
      state: true,
    },
    _height: {
      type: Number,
      state: true,
    },
    _scrolled: {
      type: Boolean,
      state: true,
    },
  }

  constructor() {
    super()

    this.headerBounds = {}
    this.currentScrollTop = 0
    this.closeWhenHidden = 'hh-details-modal'
    this.header = this.querySelector('hh-header')
    this.announcementBar = this.querySelector('#shopify-section-announcement-bar')
    this._state = -1
    this._scrolled = false
  }

  connectedCallback() {
    super.connectedCallback()
    this.onScrollHandler = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScrollHandler)
    this.createObserver()
    setTimeout(() => {
      this.setSpacerHeight()
    }, 0)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect
      observer.disconnect()
    })

    observer.observe(this)
  }

  setSpacerHeight() {
    const announcementBarEl = this.querySelector(
      '#shopify-section-announcement-bar'
    )
    const { height: announcementBarHeight } =
      announcementBarEl?.getBoundingClientRect() || { height: 0 }
    const headerEl = this.querySelector('hh-header')
    const { height: headerHeight } = headerEl?.getBoundingClientRect() || {
      height: 0,
    }

    const height = headerHeight + announcementBarHeight
    document.documentElement.style.setProperty(
      '--hh-sticky-header-height',
      `${height}px`
    )
    document.documentElement.style.setProperty(
      '--hh-header-height',
      `${height}px`
    )
    this._height = height
    this._state = 0
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    // Only update _scrolled when crossing the threshold
    const shouldBeScrolled = scrollTop > 10
    if (this._scrolled !== shouldBeScrolled) {
      this._scrolled = shouldBeScrolled
      if (this.announcementBar) {
        this.style.transform = shouldBeScrolled ? `translateY(-${this.announcementBar.offsetHeight}px)` : 'translateY(0)'

        setTimeout(() => {
          this.announcementBar.style.display = shouldBeScrolled ? 'none' : ''
          this.style.transition = 'none';
          this.style.transform = !shouldBeScrolled ? 'translateY(0)' : `translateY(-${this.announcementBar.offsetHeight}px)`
        }, 300) // reset transition after 300ms

        setTimeout(() => {
          this.style.transition = 'transform 300ms ease-in-out'
        }, 500) // reset transition after 500ms
      }
    }

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      if (!document.body.classList.contains('overflow-hidden'))
        requestAnimationFrame(this.hide.bind(this))
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.reveal.bind(this))
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this))
    }

    this.currentScrollTop = scrollTop
  }

  hide() {
    if (this._state === 1) {
      return
    }
    this._state = 1

    utils.all(this.closeWhenHidden, this.header).map((element) => {
      element.setAttribute('open', false)
    })
  }

  reveal() {
    if (this._state === 2) {
      return
    }
    this._state = 2
  }

  reset() {
    if (this._state === 0) {
      return
    }
    this._state = 0
  }

  render() {
    return html`<div
        part="container ${this._scrolled ? '' : 'container-not-scrolled'}"
        class="container"
        style="${styleMap({
          backgroundColor: this._scrolled ? '#FDFCF8' : 'transparent',
        })}"
      >
        <slot></slot>
      </div>`
  }

  static styles = css`
    .container {
      left: 0;
      width: 100%;
      z-index: var(--hh-z-index, 100);
      transform: translateY(0);
      transition: transform var(--hh-duration-long, 500ms), background-color var(--hh-duration-default, 300ms);
      background-color: var(--hh-background, transparent);
    }
  `
}

customElements.define('hh-sticky-header', HHStickyHeader)
